import React, { useState, useEffect } from 'react'
import { useNavigate } from 'react-router'
import { useFetchAuthorisation, authorisationConverter, useFetchUserData } from '../../utils/AppFunctions'

import 'react-toastify/dist/ReactToastify.css';
import AdminLayout from '../../layouts/AdminLayout'
import { MdAdd, MdEdit } from 'react-icons/md';
import { tidy_date, tidy_date_raw, tidy_frequency_name, tidy_time_difference } from '../../utils/helper';
import { get_all_prayer_lists } from '../../api/prayerAPI';
import DataTable from '../../components/ui/DataTable';
import Button from '../../components/ui/Button';

export default function PrayerPage() {
  const navigate = useNavigate()
  const { isAuthorised, userRole } = useFetchAuthorisation("user")
  let user_data = useFetchUserData()

  const [prayerListData, setPrayerListData] = useState([])
  const [loading, setLoading] = useState(true)
  const [query, setQuery] = useState("")

  useEffect(() => {
    fetchPrayerList()
  }, [])

  const fetchPrayerList = async () => {
    setLoading(true)
    try {
      const data = await get_all_prayer_lists();
      if (data?.status === 200) {
        setPrayerListData(data.data);
      }
    } catch (err) {
      // Optionally handle error
    }
    setLoading(false);
  }

  const table_columns = [
    {
      header: "Title",
      accessor: "title"
    },
    {
      header: "Description",
      accessor: "description"
    },
    {
      header: "Last Updated",
      accessor: "updatedAt",
      modifier: (data) => `${tidy_date(data)} (${tidy_time_difference(data)})`
    }
  ]



  return (
    <AdminLayout
      navSelected={"Corporate Prayer"}
      toolbar={
        <>
          <h1 className='text-lg font-semibold text-gray-900'>Prayer Requests</h1>
          <button
            className="inline-flex items-center px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white text-sm font-medium rounded-lg shadow-sm transition-colors duration-200 gap-2"
            onClick={() => {
              navigate("/admin/prayer/details?prayer_list_id=new")
            }}
          >
            <MdAdd size={16} />
            New Prayer
          </button>
        </>
      }
    >
      {/* <div className="column items-center justify-between w-100 mb-40">
        <input
          type="text"
          placeholder="Search..."
          className='text-input w-100'
          value={query}
          onChange={(e) => {
            setQuery(e.target.value)
          }}
        />
      </div> */}

      {loading ? (
        <div className="flex-row items-center flex justifyCenter w-100">
          <h1>Loading...</h1>
        </div>
      ) : (
        <div className="w-100">
          <DataTable
            columns={table_columns}
            data={prayerListData}
            enableActions
            actions={(row) => {
              return (
                <div className="flex gap-2">
                  <Button variant="outline" size="sm" icon={MdEdit} onClick={() => navigate(`/admin/prayer/details?prayer_list_id=${row.id}`)}>
                    Edit
                  </Button>
                </div>
              )
            }}
          />
          {/* {prayerListData.map((prayer, index) => {
            if (!prayer.title) return 
            return (
              <div
                key={index}
                className="flex-row items-center flex justify-between w-100 card mt-10"
              >
                <div className="">

                  <h3>{prayer.title}</h3>
                  <h3 className='card-subtitle'>{prayer.description}</h3>
                </div>
                <button
                  className="button"
                  onClick={() => {
                    navigate("/admin/prayer/details?prayer_list_id=" + prayer.id)
                  }}
                >
                  View
                </button>
              </div>
            )
          })} */}
        </div>
      )}
    </AdminLayout>
  )
}
